import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import LandingPage from './pages/LandingPage'
import EntrePage from './pages/EntrePage'
import ContactSalesPage from './pages/ContactSalesPage'
import VideosPage from './pages/VideosPage'
import VideoPlayerPage from './pages/VideoPlayerPage'
import TagsPage from './pages/TagsPage'
import TagSearchPage from './pages/TagSearchPage'
import MyPage from './pages/MyPage'
import InformationPage from './pages/InformationPage'
import SupportPage from './pages/SupportPage'
import AnnouncementsPage from './pages/AnnouncementsPage'
import AdminLoginPage from './pages/AdminLoginPage'
import AdminPage from './pages/AdminPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import TeacherStudentDetailPage from './pages/TeacherStudentDetailPage'
import TeacherHomePage from './pages/TeacherHomePage'
import HomeworkPage from './pages/HomeworkPage'
import HomeworkCatalogPage from './pages/HomeworkCatalogPage'
import HomeworkDetailPage from './pages/HomeworkDetailPage'
import TeacherSchoolHomeworkPage from './pages/TeacherSchoolHomeworkPage'
import ChatPage from './pages/ChatPage'

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin routes without layout */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminPage />} />

        {/* Auth routes without layout */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Landing page without layout (has its own custom header) */}
        <Route path="/" element={<LandingPage />} />

        {/* アントレ部の紹介ページ（公開サイト・独自ヘッダー） */}
        <Route path="/entre" element={<EntrePage />} />
        
        {/* Videos page without layout (has its own custom header) */}
        <Route path="/videos" element={<VideosPage />} />

        {/* Announcements page without layout (has its own header) */}
        <Route path="/announcements" element={<AnnouncementsPage />} />

        {/* Regular routes with layout */}
        <Route path="/contact-sales" element={<Layout><ContactSalesPage /></Layout>} />
        <Route path="/video/:videoId" element={<Layout><VideoPlayerPage /></Layout>} />
        <Route path="/tags" element={<Layout><TagsPage /></Layout>} />
        <Route path="/tags/:tagName" element={<Layout><TagSearchPage /></Layout>} />
        <Route path="/mypage" element={<Layout><MyPage /></Layout>} />
        <Route path="/teacher" element={<TeacherHomePage />} />
        {/* 宿題IDつきのURLは提出一覧を開く。同じ element なので一覧⇄提出一覧で再マウントされない */}
        <Route path="/teacher/homework/:homeworkId?" element={<TeacherSchoolHomeworkPage />} />
        <Route path="/teacher/students/:studentId" element={<Layout><TeacherStudentDetailPage /></Layout>} />
        <Route path="/information" element={<Layout><InformationPage /></Layout>} />
        <Route path="/support" element={<Layout><SupportPage /></Layout>} />
        <Route path="/homework" element={<Layout><HomeworkPage /></Layout>} />
        <Route path="/homework/system" element={<Layout><HomeworkCatalogPage /></Layout>} />
        <Route path="/homework/:id" element={<Layout><HomeworkDetailPage /></Layout>} />
        <Route path="/chat" element={<Layout><ChatPage /></Layout>} />
      </Routes>
    </Router>
  )
}

export default App
